module.exports = __webpack_public_path__ + "img/Hauge_Dikteren_fra_Hardanger.9d175084.jpg";